import 'bootstrap/dist/css/bootstrap.min.css';
const PatientQueueList = ({ patients}) => {
  return (
     <div className="table-responsive">
                    <table className="table table-bordered align-middle text-center">
                        <thead className="table-light">
                            <tr>
                                <th>Token #</th>
                                <th>Patient Name</th>
                                <th>Emergency</th>
                                <th>Status</th>
                            </tr>
                        </thead>
                        <tbody>
                            {patients?.map((patient) => (
                                <tr key={patient.token_id}>
                                    <td>{patient.token_no}</td>
                                    <td>{patient.patient_name}</td>
                                    <td>{patient.emergency === "Y" ? "Yes" : "No"}</td>
                                    <td>
                                        <span className="status-dot me-2"></span>
                                        {patient.status}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
  );
};

export default PatientQueueList;